<div class="data-sources">
  <h3>{{ 'Daily weather data updates' | translate }}</h3>
  <div class="sources-list">
    @for (source of sources; track source) {
      <p>
        <a class="source-link">
          {{ source.name | translate }}: {{ source.date | date:'dd.MM.yyyy' }}
        </a>
      </p>
    }
  </div>
</div>
